import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/app/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_HQNyLQlVwt from "/app/node_modules/nuxt3-meta-pixel/dist/runtime/plugin.mjs";
import composition_sLxaNGmlSL from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_eTVJQYlCmx from "/app/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import auth_vT9JWWT9pN from "/app/plugins/auth.ts";
import user_service_axios_mm6yR7fSJg from "/app/plugins/user-service-axios.ts";
import vee_validate_KcKlKmvCrJ from "/app/plugins/vee-validate.ts";
import sentry_3AyO8nEfhE from "/app/plugins/sentry.ts";
import filters_VNgPjx6zHj from "/app/plugins/filters.ts";
import apollo_1ILFkzpYSr from "/app/plugins/apollo.ts";
import bootstrap_3sbVBTpf50 from "/app/plugins/bootstrap.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  plugin_HQNyLQlVwt,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  plugin_eTVJQYlCmx,
  chunk_reload_client_UciE0i6zes,
  auth_vT9JWWT9pN,
  user_service_axios_mm6yR7fSJg,
  vee_validate_KcKlKmvCrJ,
  sentry_3AyO8nEfhE,
  filters_VNgPjx6zHj,
  apollo_1ILFkzpYSr,
  bootstrap_3sbVBTpf50
]